/**
 * Precision Corrective Action Plan — module entry.
 *
 * Renders one of three views inside the existing Core layout:
 *   - list       overview of CAPs in the org
 *   - detail     single-screen CAP page (the "one screen" UX)
 *   - new        draft a CAP from a finding or from scratch
 *
 * No internal tab bar, no nested sidebars. Section progression on the detail
 * page is by scroll, not by route. Plain language throughout.
 */

import React, { useState, useEffect } from 'react';
import CapList from './CapList';
import CapDetail from './CapDetail';
import CapNew from './CapNew';
import CapReports from './CapReports';

export default function CAPCommandCenter({ user }) {
  // Deep link from COA, POM, or anywhere else: ProtectedApp stashes a cap_id
  // in sessionStorage when it sees ?cap_id=<uuid> on the URL. We open straight
  // to the detail page if one is present, then clear it.
  const initialDeepCapId = (() => {
    try {
      const v = sessionStorage.getItem('pcg_open_cap_id');
      if (v) sessionStorage.removeItem('pcg_open_cap_id');
      return v || null;
    } catch { return null; }
  })();

  const [view, setView] = useState(initialDeepCapId ? 'detail' : 'list');
  const [selectedId, setSelectedId] = useState(initialDeepCapId);

  const openList = () => { setSelectedId(null); setView('list'); };
  const openDetail = (id) => { setSelectedId(id); setView('detail'); };
  const openNew = () => { setSelectedId(null); setView('new'); };
  const openReports = () => { setSelectedId(null); setView('reports'); };

  return (
    <div className="h-full w-full overflow-auto bg-[#f8fafc]">
      {view === 'list'    && <CapList    user={user} onOpen={openDetail} onNew={openNew} onReports={openReports} />}
      {view === 'detail'  && <CapDetail  user={user} capId={selectedId} onBack={openList} />}
      {view === 'new'     && <CapNew     user={user} onCreated={openDetail} onCancel={openList} />}
      {view === 'reports' && <CapReports user={user} onBack={openList} />}
    </div>
  );
}
